import { useRecoilValue } from "recoil";
import { selectIsLoggedIn } from "../state/auth";

const useIsLoggedIn = () => {
    return useRecoilValue(selectIsLoggedIn)
};

export default useIsLoggedIn;